import React, { PureComponent } from 'react'
import { Guardian } from '@xaamin/guardian';

import { Http } from '../../../../support';
import LoadingButton from '../../../../facturotopia/LoadingButton';

class TimbradoSftpItemActions extends PureComponent {
  state = {
    busy: false,
    retry: false
  }

  handleOnDownloadActionClick = async () => {
    this.setState({
      busy: true
    });

    try {
      const response = await Http.get(`${window.BONJOUR_URL}/api/timbrado-tickets/${this.props.selectedRows[0].id}/download`, { responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo original'
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  handleOnRetryStampActionClick = async () => {
    this.setState({
      retry: true
    });

    const { selectedRows } = this.props;

    const retryTickets = selectedRows.filter(function (item) {
      return item.status === -2 || item.status === -3
    }).map(function(item) {
      return item.id;
    });

    const body = {
      tickets: retryTickets
    }

    try {
      const response = await Http.post(`api/timbrado-tickets`, body);

      if (!!response) {
        this.renderResult(response);
      }
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message
      });
    } finally {
      this.setState({
        retry: false
      });
    }
  }

  renderResult = async (result) => {
    window.ToastManager.show({
      variant: 'success',
      title: 'Reintento de timbrado.',
      message: result.message ?? ''
    })
  }

  render() {
    const { selectedRows } = this.props;
    const { busy, retry } = this.state;

    const retryStampTickets = selectedRows.filter(function (item) {
      return item.status === -2 || item.status === -3
    });

    return (
      <>
        { (selectedRows.length === 1) && (
          <>
            { (selectedRows[0].status === -2 || selectedRows[0].status === -3) && Guardian.allows('timbrado.sftp.descargar.archivo.original') && (
              <LoadingButton
                variant="secondary"
                className="mr-2"
                loading={ busy }
                onClick={ this.handleOnDownloadActionClick }
              >
                { busy === true ? 'Descargando' : 'Descargar original' }
              </LoadingButton>
            )}
          </>
        )}

        { (retryStampTickets.length > 0) && Guardian.allows('timbrado.sftp.reintentar.timbrado') && (
          <LoadingButton
            variant="secondary"
            className="mr-2"
            loading={ retry }
            onClick={ this.handleOnRetryStampActionClick }
          >
            { retry === true ? 'Procesando...' : 'Reintentar' }
          </LoadingButton>
        )}
      </>
    )
  }
}

export default TimbradoSftpItemActions;